import React from "react";
import nursingHomeStore from "@source/store/nursingHomeStore";
import {canViewConsentTemplates, hasConsentPermission} from "@source/utils/consentAccess";
import {OrganizationPermissionsEnum} from "@source/api/models/permissionsModels";
import {CategoryDetail} from "./categoryDetail";
import {ConsentRequestState} from "@source/components/consentDocuments";
import ConsentDocumentsLayout from "../consentDocumentsLayout";

export const CategoryEditorPage = () => {
  const organizationId = nursingHomeStore.activeNursingHome?.organization?._id || "";
  return <ConsentDocumentsLayout>{organizationId ? <CategoryDetail organizationId={organizationId} canManage={hasConsentPermission(OrganizationPermissionsEnum.MANAGE_CONSENT_CATEGORIES)} canReadTemplates={canViewConsentTemplates()}/> : <ConsentRequestState variant="empty" title="Select a nursing home" description="Choose a nursing home with an organization to view Form Categories."/ >}</ConsentDocumentsLayout>;
};
